import { render, staticRenderFns } from "./share-dropdown.vue?vue&type=template&id=a51452ba"
import script from "./share-dropdown.vue?vue&type=script&lang=js"
export * from "./share-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports